module.exports = __webpack_public_path__ + "img/broadchat.13f69e59.svg";